import * as React from "react"
import Button from "@mui/material/Button"
import "./styles.css"
import { Loading } from "../loading/loading"
export const Buttom: React.FC<{ text: string, onClick?: () => void, id: string, disabled?: boolean, loadingButton?: boolean, color?: string }> = ({ ...props }) => {
  const { text, id, loadingButton, disabled, onClick, color } = props
  return (
    <div className="w-100 d-flex justify-content-center ">
    <Button id={id}
      className="buttom"
      onClick={!loadingButton ? onClick : void 0}
      variant="contained"
      style={{ width: "100%", opacity: disabled ? 0.6 : 1, backgroundColor: color ? color : "#332E1A" }}
      disabled={disabled}
      >
      {loadingButton ? <Loading /> : text}</Button >
      </div>
  )
}
